// ------------------------------------------------------------------------------------
// 指導員サイト 教習生編集画面の表示切り替え処理
// - 登録ボタンのconfirm
// - 連絡方法の表示切り替え

const changeTargetElementDisabledStatus = (target, isDisable) => {
  if (target === null) return;

  if (isDisable) {
    target.setAttribute('disabled', true);
  } else {
    target.removeAttribute('disabled');
  }
};

export default () => {
  const form = document.getElementById('student-form');
  if (!form) return;

  // 登録ボタンクリック時
  const preStudentCoreSystemNumber = document.getElementById('student_core_system_number').value;
  form.addEventListener('submit', function (event) {
    const studentCoreSystemNumber = document.getElementById('student_core_system_number').value;
    if (
      preStudentCoreSystemNumber !== studentCoreSystemNumber &&
      studentCoreSystemNumber.slice(0, 5) === 'test_'
    ) {
      if (!window.confirm('教習生はテスト用ユーザとして作成されますがよろしいですか？')) {
        event.stopPropagation();
        event.preventDefault();
      }
    }
  });

  // 連絡方法の表示切り替え
  const email = document.getElementById('student_email');
  const phone = document.getElementById('student_phone');
  const submitWithEmailBtn = document.getElementById('send-email-btn');

  // 学校がSMS対応していたらphoneが存在する
  if (phone) {
    window.addEventListener('load', function () {
      changeTargetElementDisabledStatus(submitWithEmailBtn, !email.value && !phone.value);
    });
    email.addEventListener('input', (e) => {
      changeTargetElementDisabledStatus(submitWithEmailBtn, !e.target.value);
    });
    phone.addEventListener('input', (e) => {
      changeTargetElementDisabledStatus(submitWithEmailBtn, !e.target.value);
    });
  } else {
    window.addEventListener('load', function () {
      changeTargetElementDisabledStatus(submitWithEmailBtn, !email.value);
    });
    email.addEventListener('input', (e) => {
      changeTargetElementDisabledStatus(submitWithEmailBtn, !e.target.value);
    });
  }
};
